import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IGlobalChatUser {
  _id: string;
  firstname: string;
  lastname?: string;
  avatar?: string;
  role?: {
    name: string;
  };
  courseAssignments?: Array<{
    courseId: string;
    courseTitle: string;
    curriculum: string;
    subject: string;
  }>;
  lastSeen?: string;
  isOnline?: boolean;
}

export interface IGlobalChatState {
  globalChatUsers: IGlobalChatUser[];
  isLoading: boolean;
  error: string | null;
}

const initialState: IGlobalChatState = {
  globalChatUsers: [],
  isLoading: false,
  error: null,
};

export const GlobalChatSlice = createSlice({
  name: 'globalChat',
  initialState,
  reducers: {
    setGlobalChatUsers: (state, action: PayloadAction<IGlobalChatUser[]>) => {
      state.globalChatUsers = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setGlobalChatLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setGlobalChatError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearGlobalChatState: (state) => {
      state.globalChatUsers = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  setGlobalChatUsers,
  setGlobalChatLoading,
  setGlobalChatError,
  clearGlobalChatState,
} = GlobalChatSlice.actions;

export default GlobalChatSlice.reducer;
